import React from 'react';
import type { ChartField } from '@/types/chat';
import { BarChart } from './BarChart';
import { ColumnChart } from './ColumnChart';
import { LineChart } from './LineChart';
import { PieChart } from './PieChart';

// bar    条形图（横向）
// column 柱状图（纵向）
// line   折线图
// pie    饼图

export type ChartType = 'bar' | 'line' | 'pie' | 'column';

export interface ChartProps {
  type: ChartType;
  data: Record<string, unknown>[];
  dimensions?: ChartField[];
  metrics?: ChartField[];
}

const ChartMap: Record<ChartType, React.FC<Omit<ChartProps, 'type'>>> = {
  bar: BarChart,
  column: ColumnChart,
  line: LineChart,
  pie: PieChart,
};

export const Chart: React.FC<ChartProps> = ({ type, data, dimensions, metrics }) => {
  const ChartComponent = ChartMap[type];
  if (!ChartComponent) return null;
  return <ChartComponent data={data} dimensions={dimensions} metrics={metrics} />;
};
